import { Col,Form } from "react-bootstrap";
import DatePicker from "./DatePicker";
import toDateOnly from "../../utilities/toDateOnly";

export const FormInputElement = ({type,ColWidth,Label,id,defaultValue,placeholder,maxLength, required,isInvalid}) => {

    if(type==null) type = "text";

  return (
    <>
    <Col xs={ColWidth}>
                <Form.Group>
                    <Form.Label htmlFor="eventTitle">{Label}</Form.Label>
                    <div className="form-control-wrap">
                        {type=="date" && <DatePicker id={id} value={toDateOnly(defaultValue)} placeholder="yyyy-mm-dd" required={required} isInvalid={isInvalid}/>}
                        {(type=="text" || type=="tel" || type=="email")  && <Form.Control id={id} type={type} maxLength={maxLength} defaultValue={defaultValue} placeholder={placeholder} required={required} isInvalid={isInvalid} />}
                        {type=="textarea" && <Form.Control id={id} as={type} maxLength={maxLength} defaultValue={defaultValue} placeholder={placeholder} required={required} isInvalid={isInvalid} />}
                        {type=="switch" && <Form.Check type="switch" id={id} defaultChecked={defaultValue} label="" isInvalid={isInvalid}/>}
                    </div>
                </Form.Group>
            </Col>
    </>
  )
}
